<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="650px"
  >
    <v-form @submit.prevent.native="$canWrite && (submit($event))">
      <v-card>
        <v-card-title>
          {{ title }}
          <v-spacer />
          <v-btn icon @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-tabs
            v-model="activeTab"
            background-color="deep-purple lighten-5"
            light
            centered
            slider-color="primary"
            v-if="tabs.length > 1"
          >
            <v-tab v-for="tab in tabs" :key="tab.key">
              {{ tab.label }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="activeTab">
            <v-tab-item :key="0">
              <v-container class="pa-5">
                <v-alert
                  :value="isAggregatorClient"
                  type="info"
                >
                  Les informations générales de ce site ne sont pas modifiables
                </v-alert>
                <v-text-field
                  v-model="form.name"
                  :disabled="isAggregatorClient"
                  label="Nom"
                  outlined
                  required
                  autofocus
                  color="primary darken-1"/>
                <v-text-field
                  v-model="form.address"
                  :disabled="isAggregatorClient"
                  label="Adresse"
                  outlined
                  required
                  color="primary darken-1"/>
                <v-row no-gutters>
                  <v-col cols="12" :md="true" class="mr-2">
                    <v-text-field
                      v-model="form.postalCode"
                      :disabled="isAggregatorClient"
                      label="Code Postal"
                      outlined
                      required
                      color="primary darken-1"/>
                  </v-col>
                  <v-col cols="12" :md="true" class="ml-2">
                    <v-text-field
                      v-model="form.city"
                      :disabled="isAggregatorClient"
                      label="Ville"
                      outlined
                      required
                      color="primary darken-1"/>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" :md="true" class="mr-2">
                    <v-text-field
                      v-model="form.phone1"
                      :disabled="isAggregatorClient"
                      label="Téléphone 1"
                      outlined
                      required
                      color="primary darken-1"/>
                  </v-col>
                  <v-col cols="12" :md="true" class="ml-2">
                    <v-text-field
                      v-model="form.phone2"
                      :disabled="isAggregatorClient"
                      label="Téléphone 2"
                      outlined
                      required
                      color="primary darken-1"/>
                  </v-col>
                </v-row>
                <v-text-field
                  v-model="form.email"
                  :disabled="isAggregatorClient"
                  label="Email"
                  outlined
                  required
                  color="primary darken-1"
                />
                <template v-if="isRealEstate">
                  <v-text-field
                    v-model="form.tenant"
                    label="Occupant"
                    outlined
                    required
                    color="primary darken-1"
                  />
                  <v-row no-gutters>
                    <v-col cols="12" :md="true">
                      <v-text-field
                        v-model="form.tenantPhone1"
                        label="Occupant Tel. 1"
                        outlined
                        required
                        color="primary darken-1"
                      />
                    </v-col>
                    <v-col cols="12" :md="true" class="ml-2">
                      <v-text-field
                        v-model="form.tenantPhone2"
                        label="Occupant Tel. 2"
                        outlined
                        required
                        color="primary darken-1"
                      />
                    </v-col>
                  </v-row>
                  <v-text-field
                    v-model="form.tenantEmail"
                    label="Occupant Email"
                    outlined
                    required
                    color="primary darken-1"
                  />
                  <v-text-field
                    v-model="form.owner"
                    label="Priopriétaire"
                    outlined
                    required
                    color="primary darken-1"
                  />
                </template>
              </v-container>
            </v-tab-item>
            <v-tab-item :key="1">
              <v-row no-gutters justify="start" align="center" class="pa-5">
                <tag-chip v-for="tag in flavoredTags" :key="tag.id" :tag="tag" @remove="removeTag" removable />
                <div>
                  <tags-dialog-list
                    :client-id="tagsClientId"
                    :maker-id="tagsMakerId"
                    :excluded-tags="flavoredTags"
                    @selected="tagSelected"
                  />
                </div>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <template v-if="activeTab === 0">
          <v-divider />
          <v-card-actions class="px-5 py-3">
            <v-spacer></v-spacer>
            <v-btn text @click="closeDialog">Annuler</v-btn>
            <v-btn
              :disabled="!$canWrite"
              color="primary darken-1"
              type="submit"
              :loading="isSaving"
            >
              {{ isUpdating ? `Modifier` : `Ajouter` }}
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  props: {
    value: Boolean,
    site: Object,
    client: Object,
    maker: {
      type: Object,
      required: false,
    },
    catchSave: Boolean,
  },
  data: () => ({
    activeTab: 0,
    form: {
      name: ``,
      address: ``,
      postalCode: null,
      city: ``,
      tenant: ``,
      tenantPhone1: ``,
      tenantPhone2: ``,
      tenantEmail: ``,
      owner: ``,
      phone1: null,
      phone2: null,
      email: ``,
      Domain_id: null,
      comment: ``,
    },
    domain: {},
    // tag: {},
    listDomain: [],
    // tags: [],
    isSaving: false,
    isAggregatorClient: false,
    isAggregatorSlug: false,
    isShowingTagsList: false,
  }),
  computed: {
    ...mapState(`model/user`, [
      `isAggregatorUser`,
    ]),
    ...mapState(`model/client`, [
      `currentAdminClient`,
      `company`,
      `isMaker`,
      `isAggregator`,
      `isRealEstate`,
    ]),
    ...mapState(`model/domain`, [
      `makerDomains`,
    ]),
    ...mapState(`ui/siteDialog`, {
      makerTags: `tags`,
    }),
    makerId() {
      return this.maker?.id || null;
    },
    areClientTagsActivated() {
      return this.isAggregator && this.isAggregatorUser;
    },
    areMakerTagsActivated() {
      return this.isMaker;
    },
    tags() {
      let tags = [];
      if (this.areClientTagsActivated) {
        tags = this.site.clientTags || [];
      } else if (this.areMakerTagsActivated) {
        tags = this.site.makerTags || [];
      }

      return tags;
    },
    flavoredTags() {
      return _.chain(this.tags)
        .map(tag => ({
          ...tag,
          $searchString: _.toLower(tag.label),
        }))
        .sortBy(`$searchString`)
        .value();
    },
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
    tabs() {
      const tabs = [
        { key: 0, label: `Infos générales` },
      ];
      if (this.areClientTagsActivated || this.areMakerTagsActivated) {
        tabs.push({ key: 1, label: `Tags` });
      }

      return tabs;
    },
    isUpdating() {
      return this.site && this.site.id;
    },
    title() {
      return this.isUpdating ? `Modifier un site` : `Ajouter un site`;
    },
    tagsClientId() {
      return this.areClientTagsActivated ? this.client.id : null;
    },
    tagsMakerId() {
      return this.areMakerTagsActivated ? this.makerId : null;
    },
  },
  methods: {
    async initLocalState() {
      this.form.name = this.isUpdating ? this.site.name : ``;
      this.form.address = this.isUpdating ? this.site.address : ``;
      this.form.postalCode = this.isUpdating ? this.site.postalCode : null;
      this.form.city = this.isUpdating ? this.site.city : ``;
      this.form.tenant = this.isUpdating ? this.site.tenant : ``;
      this.form.tenantPhone1 = this.isUpdating ? this.site.tenantPhone1 : ``;
      this.form.tenantPhone2 = this.isUpdating ? this.site.tenantPhone2 : ``;
      this.form.tenantEmail = this.isUpdating ? this.site.tenantEmail : ``;
      this.form.owner = this.isUpdating ? this.site.owner : ``;
      this.form.phone1 = this.isUpdating ? this.site.phone1 : null;
      this.form.phone2 = this.isUpdating ? this.site.phone2 : null;
      this.form.email = this.isUpdating ? this.site.email : ``;
      this.isAggregatorSlug = !this.company.isRoot;
      this.isAggregatorClient = this.currentAdminClient.slug !== `` && !this.isAggregatorSlug;
      await this.$store.dispatch(`model/domain/fetchMakerDomains`);
      this.listDomain = [{ name: `Aucun`, id: 0 }];
      [this.domain] = this.listDomain;
      this.makerDomains.forEach(domain => {
        if (this.site.Domain_id === domain.id) {
          this.domain = { name: domain.name, id: domain.id };
        }
        this.listDomain.push({ name: domain.name, id: domain.id });
      });
      this.form.comment = this.isUpdating ? this.site.comment : ``;
      this.isSaving = false;
    },
    async submit() {
      if (this.catchSave) {
        return this.$emit(`save`, {
          ...this.site,
          ...this.form,
        });
      }
      this.isSaving = true;
      this.form.Domain_id = this.domain.id !== 0 ? this.domain.id : null;
      await this.$store.dispatch(this.isUpdating ? `model/site/saveSite` : `model/site/addSite`, {
        ...this.form,
        Client_id: this.isUpdating ? this.site.Client_id : this.client,
        Maker_id: this.company.id,
        Site_id: this.isUpdating ? this.site.id : null,
      });
      this.isSaving = false;
      this.isOpened = false;
      return this.$emit(`save`);
    },
    async tagSelected(tag) {
      if (this.areClientTagsActivated) {
        await this.$store.dispatch(`ui/siteDialog/addClientTag`, {
          clientId: this.client.id,
          siteId: this.site.id,
          tagId: tag.id,
        });
        this.site.clientTags = _.chain(this.site.clientTags)
          .concat(tag)
          .sortBy(tag => _.toLower(tag.label))
          .value();
      } else if (this.areMakerTagsActivated) {
        await this.$store.dispatch(`ui/siteDialog/addMakerTag`, {
          makerId: this.makerId,
          siteId: this.site.id,
          tagId: tag.id,
        });
        this.site.makerTags = _.chain(this.site.makerTags)
          .concat(tag)
          .sortBy(tag => _.toLower(tag.label))
          .value();
      }
    },
    async removeTag(tag) {
      if (this.areClientTagsActivated) {
        await this.$store.dispatch(`ui/siteDialog/removeClientTag`, {
          clientId: this.client.id,
          siteId: this.site.id,
          tagId: tag.id,
        });
        this.site.clientTags = _.reject(this.site.clientTags, { id: tag.id });
      } else if (this.areMakerTagsActivated) {
        await this.$store.dispatch(`ui/siteDialog/removeMakerTag`, {
          makerId: this.makerId,
          siteId: this.site.id,
          tagId: tag.id,
        });
        this.site.makerTags = _.reject(this.site.makerTags, { id: tag.id });
      }
    },
    closeDialog() {
      this.isOpened = false;
      this.$emit(`close`);
    },
  },
  beforeMount() {
    if ((!this.site || !this.site.id) && !this.client) {
      console.error(`[components/SiteDialog] Please give site OR client`); // eslint-disable-line
    } else {
      this.initLocalState();
    }
  },
  watch: {
    isOpened() {
      setTimeout(() => {
        this.activeTab = 0;
      }, 100);
    },
  },
};
</script>
